var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuShare1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.25,
    height: 39.25,
    viewBox: "0 0 39.25 39.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M19.626,39.25A19.63,19.63,0,0,1,11.987,1.542,19.63,19.63,0,0,1,27.264,37.708,19.5,19.5,0,0,1,19.626,39.25Zm2.148-16.514a1.055,1.055,0,0,0,0,2.109h3.163a5.272,5.272,0,0,0,0-10.545H21.773a1.055,1.055,0,0,0,0,2.109h3.163a3.163,3.163,0,0,1,0,6.326ZM14.392,14.3a5.272,5.272,0,0,0,0,10.545h3.163a1.055,1.055,0,1,0,0-2.109H14.392a3.163,3.163,0,0,1,0-6.326h3.163a1.055,1.055,0,1,0,0-2.109ZM16.5,18.518a1.054,1.054,0,1,0,0,2.108h6.326a1.054,1.054,0,1,0,0-2.108Z",
    fill: "#f77f00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuShare1);
export default __webpack_public_path__ + "static/media/menu-share1.3cdedf35d7e2b17c80e8f492c519f6c9.svg";
export { ForwardRef as ReactComponent };